function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27 6V26C26.9994 26.5302 26.7885 27.0386 26.4135 27.4135C26.0386 27.7885 25.5302 27.9994 25 28H20.5C19.9698 27.9994 19.4614 27.7885 19.0865 27.4135C18.7115 27.0386 18.5006 26.5302 18.5 26V6C18.5006 5.46975 18.7115 4.9614 19.0865 4.58646C19.4614 4.21151 19.9698 4.00061 20.5 4H25C25.5302 4.00061 26.0386 4.21151 26.4135 4.58646C26.7885 4.9614 26.9994 5.46975 27 6ZM11.5 4H7C6.46975 4.00061 5.9614 4.21151 5.58646 4.58646C5.21151 4.9614 5.00061 5.46975 5 6V26C5.00061 26.5302 5.21151 27.0386 5.58646 27.4135C5.9614 27.7885 6.46975 27.9994 7 28H11.5C12.0302 27.9994 12.5386 27.7885 12.9135 27.4135C13.2885 27.0386 13.4994 26.5302 13.5 26V6C13.4994 5.46975 13.2885 4.9614 12.9135 4.58646C12.5386 4.21151 12.0302 4.00061 11.5 4Z",
  fill: "#A8A29E"
});

function SvgPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.ab932785.svg";
export { ForwardRef as ReactComponent };